module.exports = __webpack_public_path__ + "036eb6fdf56ec322d50f4387ae845da7.svg";